import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import { BASE_URL } from "../helpers/constants"
function SEO({ description, lang, meta, title, path = "", imageUrl = "", keywords = "" }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )

  const metaDescription = description || site.siteMetadata.description
  const url = `${BASE_URL}/${path}`

  const schemaOrgJSONLD = {
    '@context': 'http://schema.org',
    '@type': 'Website',
    url,
    name: title,
    "name": title,
    description: metaDescription,
    "image": imageUrl
  }

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={`${site.siteMetadata.title} - %s`}
      defaultTitle={site.siteMetadata.title}
      meta={[
        { name: `description`, content: metaDescription },
        { name: `keywords`, content: keywords },
        { property: `title`, content: title },
        { property: "og:url", content: url },
        { property: "og:description", content: metaDescription },
        { property: "og:title", content: title },
        { property: "og:image", content: imageUrl },

        { itemprop: "name", content: title },
        { itemprop: "description", content: metaDescription },
        { itemprop: "url", content: url },
        { itemprop: "image", content: imageUrl },

      ].concat(meta)}
    >
      <script type="application/ld+json">
        {JSON.stringify(schemaOrgJSONLD)}
      </script>
    </Helmet>
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object)
}

export default SEO